import { useEffect, useState } from 'react'

export function useDeviceType() {
	const [isMobile, setIsMobile] = useState(false)
	const [isTablet, setIsTablet] = useState(false)
	const [isDesktop, setIsDesktop] = useState(true)

	useEffect(() => {
		const checkDeviceType = () => {
			const width = window.innerWidth

			setIsMobile(width < 768) // < 768px = mobile
			setIsTablet(width >= 768 && width < 1024) // 768px - 1024px = tablet
			setIsDesktop(width >= 1024) // >= 1024px = desktop
		}

		// Check on mount
		checkDeviceType()

		// Add event listener
		window.addEventListener('resize', checkDeviceType)

		// Cleanup
		return () => window.removeEventListener('resize', checkDeviceType)
	}, [])

	return { isMobile, isTablet, isDesktop }
}
